import { Tab } from '@/App/tabs/Tab/Tab.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTabIds } from '@/store/tabs/selectors.ts';

export function TabsList() {
  const tabIds = useAppSelector(selectTabIds);

  return tabIds.map((tabId) => <Tab key={tabId} tabId={tabId} />);
}
